
export class CoverageRange {
    constructor(
        public Min: number,
        public Max: number
    ) {
    }
} 
